export default __webpack_public_path__ + "static/media/down-min.751781c5.gif";